import * as React from 'react';
import assertions from 'lib/assertions';
import Columns2 from 'components/Columns2';
import FormElement from 'components/FormElement';
import Heading from 'components/Heading';
import Input from 'components/Input';
import Select from 'components/Select';
// @ts-ignore
import InputValueConstants from 'constants/InputValueConstants';
import { REQUESTER_ROLE_OPTIONS } from 'admin/constants/AdminUpgrade';
import PhoneNumberMaskedInput from 'components/PhoneNumberMaskedInput';
// @ts-ignore
import Row from 'components/Row';
import Text from 'components/Text';
import './styles/AdminUpgradePlanInfoInputForm.scss';

type FormFields = {
  requesterFirstName?: string;
  requesterLastName?: string;
  requesterPhone?: string;
  requesterEmail?: string;
  requesterRole?: string;
};

export type Props = {
  requesterFirstName?: string;
  requesterLastName?: string;
  requesterPhone?: string;
  requesterEmail?: string;
  requesterRole?: string;
  orgUuid?: string;
  showRole?: boolean;
  onUpdate: (stateUpdate: FormFields) => void;
};
class AdminUpgradePlanRequesterInfo extends React.Component<Props> {
  renderRoleRow = () => {
    return (
      <Columns2>
        <FormElement
          label={'Role'}
          validate={role => {
            assertions.notEmpty(role);
          }}
          onValidChange={role => {
            this.props.onUpdate({ requesterRole: role });
          }}
          onInvalidChange={() => this.props.onUpdate({ requesterRole: undefined })}
          element={Select}
          elementProps={{
            options: REQUESTER_ROLE_OPTIONS,
            placeholder: 'Select...',
            className: 'requester-role-input',
            value: this.props.requesterRole,
          }}
        />
      </Columns2>
    );
  };
  render = () => {
    return (
      <section className="AdminUpgradePlanInfoInputForm-about" data-test="about-requester-form">
        <Row size="large">
          <Heading level="2" levelStyle="5" data-test="about-requester-header">
            <Text size="medium" weight="normal" color="graphite">
              About you
            </Text>
          </Heading>
        </Row>
        <Columns2>
          <FormElement
            label={'First name'}
            validate={e => {
              assertions.notEmpty(e.target.value);
              assertions.lengthLesserThanOrEqualTo(
                e.target.value,
                InputValueConstants.FIRST_NAME_LENGTH
              );
            }}
            onValidChange={e => this.props.onUpdate({ requesterFirstName: e.target.value })}
            onInvalidChange={() => this.props.onUpdate({ requesterFirstName: undefined })}
            element={Input}
            elementProps={{
              'data-test-selector': 'first-name-input',
              value: this.props.requesterFirstName,
            }}
          />
          <FormElement
            label={'Last name'}
            validate={e => {
              assertions.notEmpty(e.target.value);
              assertions.lengthLesserThanOrEqualTo(
                e.target.value,
                InputValueConstants.LAST_NAME_LENGTH
              );
            }}
            onValidChange={e => this.props.onUpdate({ requesterLastName: e.target.value })}
            onInvalidChange={() => this.props.onUpdate({ requesterLastName: undefined })}
            element={Input}
            elementProps={{
              'data-test-selector': 'last-name-input',
              value: this.props.requesterLastName,
            }}
          />
        </Columns2>
        {this.props.showRole && this.renderRoleRow()}
        <Columns2>
          <FormElement
            label={'Phone number'}
            validate={e => {
              assertions.number(e.raw, 'Invalid phone number.');
              assertions.completePhoneNumber(e.raw, 'Invalid phone number.');
            }}
            onValidChange={e => this.props.onUpdate({ requesterPhone: e.raw })}
            onInvalidChange={() => this.props.onUpdate({ requesterPhone: undefined })}
            element={PhoneNumberMaskedInput}
            elementProps={{
              'data-test-selector': 'phone-number-input',
              value: this.props.requesterPhone,
            }}
          />
          <FormElement
            label={'Work email'}
            validate={e => {
              assertions.email(e.target.value);
              assertions.notEmpty(e.target.value);
            }}
            onValidChange={e => {
              this.props.onUpdate({ requesterEmail: e.target.value });
            }}
            onInvalidChange={() => this.props.onUpdate({ requesterEmail: undefined })}
            element={Input}
            elementProps={{
              'data-test-selector': 'email-input',
              value: this.props.requesterEmail,
            }}
          />
        </Columns2>
      </section>
    );
  };
}

export { AdminUpgradePlanRequesterInfo };
export default AdminUpgradePlanRequesterInfo;
